<template>
  <div>
    <!-- First Row -->
    <b-row class="mb-3">
      <b-col cols="12" xl="9" lg="8" md="7">
        <dedicated-fund-list-dedicated-fund-info-card
          :fetchData="refetchData"
        />
      </b-col>
      <b-col cols="12" md="5" xl="3" lg="4">
        <dedicated-fund-list-dedicated-fund-plan-card :deducted-fund-amount="deductedFundAmountDetails" />
      </b-col>
    </b-row>

    <b-row>
      <b-tabs pills>
        <b-tab
          v-if="$can('read_transactions_fund_history', 'Caisse Générale')"
          active
        >
          <template #title>
            <feather-icon icon="MenuIcon" />
            <span>Liste des déductions</span>
          </template>

          <custom-list
            ref="refDedicatedFundListTable"
            concernedList="historiques"
            :items="getDedicatedFundHistories"
            :total="totalDedicatedFundList"
            :fields="dedicatedFundFields"
            :perPage.sync="dfPerPage"
            :pageOptions="dfPageOptions"
            :currentPage.sync="dfCurrentPage"
            :sortBy.sync="dfSortBy"
            :sortDesc.sync="dfSortDesc"
            :sortDirection="dfSortDirection"
            :filter.sync="dfFilter"
          />
        </b-tab>
      </b-tabs>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BTabs, BTab } from "bootstrap-vue";

import DedicatedFundListDedicatedFundInfoCard from "./DedicatedFundListDedicatedFundInfoCard.vue";
import DedicatedFundListDedicatedFundPlanCard from "./DedicatedFundListDedicatedFundPlanCard.vue";
import useDedicatedFundList from "../useDedicatedFundList";
import CustomList from "@/components/fund-history/customList.vue";

export default {
  name: "DedicatedFunList",
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,

    // Local Components
    DedicatedFundListDedicatedFundInfoCard,
    DedicatedFundListDedicatedFundPlanCard,
    CustomList,
  },
  setup() {
    const {
      getDedicatedFundHistories,
      refetchData,
      dedicatedFundFields,

      //dedicated fund
      totalDedicatedFundList,
      dfPerPage,
      dfPageOptions,
      dfCurrentPage,
      dfSortBy,
      dfSortDesc,
      dfSortDirection,
      dfFilter,
      refDedicatedFundListTable,

      totalDebitAndCredit,

      requests,
      budgets,
      deductedFundAmountDetails,
      toggleView,
    } = useDedicatedFundList();

    return {
      getDedicatedFundHistories,
      refetchData,
      dedicatedFundFields,

      //deducted fund
      dfPerPage,
      totalDedicatedFundList,
      dfPageOptions,
      dfCurrentPage,
      dfSortBy,
      dfSortDesc,
      dfSortDirection,
      dfFilter,
      refDedicatedFundListTable,

      totalDebitAndCredit,

      requests,
      budgets,
      deductedFundAmountDetails,
      toggleView,
    };
  },
  data() {
    return {
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = `Transaction ligne: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
  },
};
</script>
